<div normal>
    <modal-default-mmaxapp>
            <div class="tarjetaconfirmar">
                <div class="titulo">
                        Medios de Pago
                </div>
                <div class="leyendaconfirmar">
                        {{medioPago}}
                </div>
                <div class="botones">
                        <button class="buttonpc whibutton" (click)="aceptar()">Aceptar</button>
                </div>
            </div>
    </modal-default-mmaxapp>
</div>